import React from 'react';
import DaysMonth from "./DaysMonth";
import DataMonth from "./DataMonth";


function GridMonth({_data, _clk}) {
    return (
        <div className="grid_month">
            <DaysMonth _data={_data}/>
            <DataMonth _data={_data} _clk={_clk}/>
        </div>
    );
}

export default GridMonth;
